<template>
  <div class="full-height" :style="cssProps">
    <div v-if="isLoading" class="d-flex flex-column align-items-center justify-content-center full-height">
      <svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" width="64px" height="64px" viewBox="0 0 128 128" xml:space="preserve">
      <rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF" /><g><circle cx="16" cy="64" r="16" :fill="'#' + info.color" fill-opacity="1"/>
      <circle cx="16" cy="64" r="16" :fill="'#' + info.color" fill-opacity="0.67" transform="rotate(45,64,64)"/>
      <circle cx="16" cy="64" r="16" :fill="'#' + info.color" fill-opacity="0.42" transform="rotate(90,64,64)"/>
      <circle cx="16" cy="64" r="16" :fill="'#' + info.color" fill-opacity="0.2" transform="rotate(135,64,64)"/>
      <circle cx="16" cy="64" r="16" :fill="'#' + info.color" fill-opacity="0.12" transform="rotate(180,64,64)"/>
      <circle cx="16" cy="64" r="16" :fill="'#' + info.color" fill-opacity="0.12" transform="rotate(225,64,64)"/>
      <circle cx="16" cy="64" r="16" :fill="'#' + info.color" fill-opacity="0.12" transform="rotate(270,64,64)"/>
      <circle cx="16" cy="64" r="16" :fill="'#' + info.color" fill-opacity="0.12" transform="rotate(315,64,64)"/>
      <animateTransform attributeName="transform" type="rotate" values="0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64" calcMode="discrete" dur="720ms" repeatCount="indefinite"></animateTransform></g></svg>
    </div>

    <div v-show="!isLoading">
    <div class="rest-block d-flex flex-column align-items-center" id="alllocation">
      <div class="main-top d-flex flex-column align-items-center" v-if="!smallHeader">
        <div
          class="logo-title d-flex flex-row justify-content-around align-items-center"
          v-if="!isMobile || isMap"
        >
          <img :src="info.logo ? info.logo : '../assets/images/sg_logo.svg'">
          <div class="d-flex flex-column logo-col" style="padding-left:15px;">
            <h1 class="title">Burger & Fries</h1>
            <h2 class="subTitle">Search or View Nearby Restaurants Below.</h2>
          </div>
        </div>
        <div class="search-block">
          <i class="fal fa-search" :class="[isCurrent === false ? 'current-button' : '']"></i>
          <input
            type="search"
            placeholder="Search for restaurants"
            v-on:input="searchEnter"
            v-model="search"
          >
          <i
            class="far fa-location-arrow"
            @click="geolocation"
            :class="[isCurrent === true ? 'current-button' : '']"
          ></i>
        </div>
      </div>
      <div  class="sticky-header d-flex flex-row justify-content-between" v-else>
        <img :src="info.logo ? info.logo : '../assets/images/sg_logo.svg'">
        <div class="sticky-search d-flex flex-row align-items-center justify-content-around" :class="showSearch? 'show-div' : ''">
          
          <i class="fal fa-search" @click="searchW"></i>
          <input ref="sear" type="search"  v-on:input="searchEnter" v-model="search" :class="showSearch ? 'show-search' : ''">
          <div class="vertical-two"></div>

          <i class="far fa-location-arrow" @click="geolocation"
            :class="[isCurrent === true ? 'current-button' : '']"></i>
        </div>
      </div>
      <div v-if="!isSearched" class="show-all d-flex jusitify-content-start">
        <h3 class="allLoc">showing all locations</h3>
      </div>
      <div class="search-res-block d-flex flex-row-reverse justify-content-around" v-else>
        <a class="view-allloc" href="#" @click.prevent="viewAll">View All Locations</a>
        <h3 class="search-res">search results</h3>
      </div>
      <div id="locationdiv" v-if="data">
        <!-- BEGIN BLOCK -->
        <!-- <div class="line-between"></div> -->
        <div v-show="showList">
          <div v-for="restaurant in viewedData" :key="restaurant.id">
            <div class="line-between"></div>
            <div
              class="location-container d-flex flex-row"
              :class="[restaurant.id === activeId ? 'active-click' : '']"
              :id="'id' + restaurant.id"
            >
              <div class="location-left d-flex flex-column" @click="zoomMarker(restaurant)">
                <h1>{{restaurant.name}}</h1>
                <div class="info-loc d-flex flex-row">
                  <div class="description d-flex flex-column justify-content-around">
                    <div class="d-flex flex-row">
                      <div class="first-col d-flex flex-column">
                        <i class="far fa-map-marker-alt"></i>
                      </div>
                      <div class="first-col d-flex flex-column">
                        <p>{{restaurant.streetaddress}}</p>
                        <p>{{restaurant.city}}, {{restaurant.state}} {{restaurant.zip}}</p>
                      </div>
                    </div>
                    <div class="d-flex flex-row">
                      <div class="first-col d-flex flex-column">
                        <i class="far fa-shopping-bag"></i>
                      </div>
                      <div class="first-col d-flex flex-column">
                        <p v-if="restaurant.candeliver && restaurant.canpickup">Delivery and Pickup</p>
                        <p v-if="restaurant.candeliver && !restaurant.canpickup">Delivery</p>
                        <p v-if="!restaurant.candeliver && restaurant.canpickup">Pickup</p>
                        
                      </div>
                    </div>
                    <div class="d-flex flex-row">
                      <div class="first-col d-flex flex-column">
                        <i class="fal fa-clock"></i>
                      </div>
                      <div class="first-col d-flex flex-column">
                        <p>Open Now</p>
                      
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="location-right d-flex align-items-center justify-content-end">
                <button
                  class="right-btn d-flex flex-row align-items-center justify-content-center"
                  @click="makeOrder(restaurant)"
                >
                  <i class="far fa-shopping-bag"></i>
                  <span>Order Now</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- END BLOCK -->
      </div>
    </div>
    <div class="right-corner flex-row justify-content-around">
      <button class="signIn d-flex align-items-center justify-content-around" @click="$router.push({name:'signin'})">
        <i class="fal fa-user-circle"></i>
        <span>Account</span>
      </button>
      <div class="vertical-line"></div>
      <button class="basket d-flex align-items-center">
        <i class="fal fa-shopping-bag"></i>
        <span>Order</span>
      </button>
    </div>
    <div class="mobile-header flex-row justify-content-around">
      <button class="mapbtn d-flex align-items-center">
        <i class="far fa-list-ul" @click="goList"></i>
      </button>
      <div class="vertical-line"></div>
      <button
        id="btnmap"
        class="signIn d-flex align-items-center justify-content-around"
        @click="buttonChange"
      >
        <i class="fal" :class="isMap? 'fa-globe-americas' : 'fa-th-list'"></i>
        <span v-if="isMap">Switch to Map</span>
        <span v-else>Switch to List</span>
      </button>

      <div class="vertical-line"></div>

      <button class="signIn d-flex align-items-center justify-content-around">
        <i class="fal fa-user-circle"></i>
      </button>
    </div>
    <div class="container-maps" v-show="showMap">
      <div id="googleMap" class="googleMaps"></div>
    </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { scroller } from "vue-scrollto/src/scrollTo";
import { get } from "http";
import { mapState } from "vuex";
export default {
  name: "startPage",
  data() {
    return {
      isLoading: true,
      data: [],
      viewedData: [],
      search: null,
      isSearched: false,
      map: null,
      markers: [],
      isMap: true,
      showMap: true,
      showList: true,
      isMobile: false,
      activeId: null,
      isCurrent: false,
      currentMarker: null,
      currentCircle: null,
      smallHeader: false,
      showSearch: false,
      bigPin: `<svg width="60px" height="74px" viewBox="0 0 60 74" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <title>pin</title>
                  <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="index/detection" transform="translate(-838.000000, -335.000000)">
                          <g id="pin" transform="translate(838.000000, 335.000000)">
                              <path d="M38,59.0549288 C33.5000495,59.5523731 30,63.3674463 30,68 C30,63.3674463 26.4999505,59.5523731 22,59.0549288 L22,59 L22.2899933,59 C9.45748002,55.5972106 0,43.9030617 0,30 C0,13.4314575 13.4314575,0 30,0 C46.5685425,0 60,13.4314575 60,30 C60,43.9030617 50.54252,55.5972106 37.7100067,59 L38,59 L38,59.0549288 Z M30,74 C28.3431458,74 27,72.6568542 27,71 C27,69.3431458 28.3431458,68 30,68 C31.6568542,68 33,69.3431458 33,71 C33,72.6568542 31.6568542,74 30,74 Z" id="bg" fill="#c12d39"></path>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" width="20px" height="24px" x="20" y="20">
                                  <path d="M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z" fill="#FFFFFF"/>
                              </svg>
                          </g>
                      </g>
                  </g>
              </svg>`,
      pin: `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>pin</title>
              <desc>Created with Sketch.</desc>
              <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="index/detection" transform="translate(-737.000000, -165.000000)">
                      <g id="pin" transform="translate(737.000000, 165.000000)">
                          <circle id="dot" fill="#C12D39" cx="12" cy="12" r="12"></circle>
                          <circle id="center" fill="#FFFFFF" cx="12" cy="12" r="4"></circle>
                      </g>
                  </g>
              </g>
          </svg>`,
      currentPin: `<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>current</title>
          <desc>Created with Sketch.</desc>
          <defs>
              <circle id="path-1" cx="128" cy="128" r="11"></circle>
              <filter x="-72.7%" y="-72.7%" width="245.5%" height="245.5%" filterUnits="objectBoundingBox" id="filter-2">
                  <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>
                  <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
                  <feGaussianBlur stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                  <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"></feComposite>
                  <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
              </filter>
          </defs>
          <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="index/detection" transform="translate(-886.000000, -428.000000)">
                  <g id="current" transform="translate(780.000000, 322.000000)">
                      <g id="Oval-Copy-2">
                          <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                          <circle stroke-opacity="0.05" stroke="#000000" stroke-width="1" fill-opacity="0.82" fill="#F8F8F8" fill-rule="evenodd" cx="128" cy="128" r="11.5"></circle>
                      </g>
                      <circle id="Oval-Copy" fill="#C12D39" cx="128" cy="128" r="7"></circle>
                      <path d="M132.384573,120.138402 C131.087204,119.413282 129.591866,119 128,119 C126.408134,119 124.912796,119.413282 123.615427,120.138402 L128,114 L132.384573,120.138402 Z" id="Combined-Shape" fill="#C12D39"></path>
                  </g>
              </g>
          </g>
      </svg>`
    };
  },
  computed: {
    ...mapState(['info']),
    cssProps() { return {
        '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
      }
    },
    color(){
      return this.info.color;
    }
  },
  watch: {
    color(){
      this.pin = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>pin</title>
              <desc>Created with Sketch.</desc>
              <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="index/detection" transform="translate(-737.000000, -165.000000)">
                      <g id="pin" transform="translate(737.000000, 165.000000)">
                          <circle id="dot" fill="#${this.info.color}" cx="12" cy="12" r="12"></circle>
                          <circle id="center" fill="#FFFFFF" cx="12" cy="12" r="4"></circle>
                      </g>
                  </g>
              </g>
          </svg>`;
          this.markers.forEach(marker => {
            marker.setIcon({
              anchor: new google.maps.Point(16, 16),
              url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(this.pin)
            })
          })
      this.bigPin = `<svg width="60px" height="74px" viewBox="0 0 60 74" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>pin</title>
              <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="index/detection" transform="translate(-838.000000, -335.000000)">
                      <g id="pin" transform="translate(838.000000, 335.000000)">
                          <path d="M38,59.0549288 C33.5000495,59.5523731 30,63.3674463 30,68 C30,63.3674463 26.4999505,59.5523731 22,59.0549288 L22,59 L22.2899933,59 C9.45748002,55.5972106 0,43.9030617 0,30 C0,13.4314575 13.4314575,0 30,0 C46.5685425,0 60,13.4314575 60,30 C60,43.9030617 50.54252,55.5972106 37.7100067,59 L38,59 L38,59.0549288 Z M30,74 C28.3431458,74 27,72.6568542 27,71 C27,69.3431458 28.3431458,68 30,68 C31.6568542,68 33,69.3431458 33,71 C33,72.6568542 31.6568542,74 30,74 Z" id="bg" fill="#${this.info.color}"></path>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" width="20px" height="24px" x="20" y="20">
                              <path d="M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z" fill="#FFFFFF"/>
                          </svg>
                      </g>
                  </g>
              </g>
          </svg>`;
      this.currentPin = `<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>current</title>
          <desc>Created with Sketch.</desc>
          <defs>
              <circle id="path-1" cx="128" cy="128" r="11"></circle>
              <filter x="-72.7%" y="-72.7%" width="245.5%" height="245.5%" filterUnits="objectBoundingBox" id="filter-2">
                  <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>
                  <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
                  <feGaussianBlur stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                  <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"></feComposite>
                  <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
              </filter>
          </defs>
          <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="index/detection" transform="translate(-886.000000, -428.000000)">
                  <g id="current" transform="translate(780.000000, 322.000000)">
                      <g id="Oval-Copy-2">
                          <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                          <circle stroke-opacity="0.05" stroke="#000000" stroke-width="1" fill-opacity="0.82" fill="#F8F8F8" fill-rule="evenodd" cx="128" cy="128" r="11.5"></circle>
                      </g>
                      <circle id="Oval-Copy" fill="#${this.info.color}" cx="128" cy="128" r="7"></circle>
                      <path d="M132.384573,120.138402 C131.087204,119.413282 129.591866,119 128,119 C126.408134,119 124.912796,119.413282 123.615427,120.138402 L128,114 L132.384573,120.138402 Z" id="Combined-Shape" fill="#${this.info.color}"></path>
                  </g>
              </g>
          </g>
      </svg>`;
    }
  },
  methods: {
    loadData() {
      let thisRef = this;
      axios
        .get("https://secure-badlands-41449.herokuapp.com/restaurants?includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP", {
          headers: { "Access-Control-Allow-Origin": "*" },
          crossdomain: true
        })
        .then(function(response) {
          thisRef.data = response.data.restaurants;
          thisRef.viewedData = thisRef.data;
          thisRef.myMap();
          thisRef.isLoading = false;
        })
        .catch(function(error) {
          console.log(error);
          thisRef.isLoading = false;
        });
    },
    searchW(){
    this.showSearch = this.showSearch ? false : true;
    console.log("SEARCH SLIDE NOT WORKING YETT")

    },
    goList()
    {
      this.$router.push({
        name:'schedule'
      })
    },
    geolocation() {
      let thisRef = this;
      thisRef.isCurrent = thisRef.isCurrent ? false : true;
      if (navigator.geolocation && thisRef.isCurrent) {
        navigator.geolocation.getCurrentPosition(function(position) {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          thisRef.map.setCenter(pos);
          thisRef.currentMarker = new google.maps.Marker({
            position: { lat: pos.lat, lng: pos.lng },
            map: thisRef.map,
            icon: {
              anchor: new google.maps.Point(16, 16),
              // url: 'data:image/svg+xml;utf-8, ' + thisRef.currentPin
              url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(thisRef.currentPin)
            }
          });
          thisRef.currentCircle = new google.maps.Circle({
            strokeColor: "#" + thisRef.info.color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#" + thisRef.info.color,
            fillOpacity: 0.35,
            map: thisRef.map,
            center: pos,
            radius: 500
          });
        });
      } else {
        thisRef.currentMarker.setVisible(false);
        thisRef.currentCircle.setVisible(false);
      }
    },
    searchEnter() {
      if (this.search) {
        this.isSearched = true;
        this.viewedData = [];
        let initialData = this.data;
        let searchParts = this.search.split(" ");
        searchParts.forEach(part => {
          initialData = this.searchByPart(initialData, part);
        });
        this.viewedData = initialData;
      } else {
        this.viewedData = this.data;
      }
    },
    searchByPart(array, part) {
      part = part.toLowerCase()
      array = array.filter(
        element =>
          element.name.toLowerCase().includes(part) ||
          element.streetaddress.toLowerCase().includes(part) ||
          element.zip.toLowerCase().includes(part)
      );
      return array;
    },
    viewAll() {
      this.search = null;
      this.viewedData = this.data;
      this.isSearched = false;
    },
    myMap() {
      let thisRef = this;
      const scrollTo = scroller();
      var mapProp = {
        center: new google.maps.LatLng(
          this.data[0].latitude,
          this.data[0].longitude
        ),
        zoom: 14,
        disableDefaultUI: true
      };
      this.map = new google.maps.Map(
        document.getElementById("googleMap"),
        mapProp
      );
      this.markers = this.data.map(function(element) {
        let marker = new google.maps.Marker({
          position: { lat: element.latitude, lng: element.longitude },
          map: thisRef.map,
          icon: {
              anchor: new google.maps.Point(16, 16),
              // url: 'data:image/svg+xml;utf-8, ' + thisRef.pin
              // url: require('../assets/images/pin.png'),
              url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(thisRef.pin)
            },
        });
        
        let options = "";
        if (element.candeliver && element.canpickup) {
          options = "Delivery and Pickup";
        } else if (element.candeliver && !element.canpickup) {
          options = "Delivery";
        } else if (!element.candeliver && element.canpickup) {
          options = "Pickup";
        }
        var contentString = `
        <div class="location-left d-flex flex-column align-items-center">
       <h1>${element.name}</h1>
       <div class="info-loc d-flex flex-row">
        <div class="description d-flex flex-column justify-content-around">
         <div class="d-flex flex-row">
          <div class="first-col d-flex flex-column">
           <i class="far fa-map-marker-alt"></i>
          </div>
          <div class="first-col d-flex flex-column">
           <p>${element.streetaddress}</p>
           <p>${element.city}, ${element.state} ${element.zip}</p>
          </div>
         </div>
         <div class="d-flex flex-row">
          <div class="first-col d-flex flex-column">
           <i class="far fa-shopping-bag"></i>
          </div>
          <div class="first-col d-flex flex-column">
           <p>${options}</p>
          </div>
         </div>
         <div class="d-flex flex-row">
          <div class="first-col d-flex flex-column">
           <i class="fal fa-clock"></i>
          </div>
          <div class="first-col d-flex flex-column">
           <p>Open Now</p>
          </div>
         </div>
        </div>
       </div>
       </div>
       <div class="location-right d-flex align-items-center justify-content-center" style="width:100%">
       <button class="popup-btn d-flex flex-row align-items-center justify-content-center">
        <i class="far fa-shopping-bag"></i>
        <span>Order Now</span>
      </button>
      </div>
      </div>
      </div>
      </div>
      `;
        var div = document.createElement('div');
        div.innerHTML = contentString;
        // div.style.display = "flex";
        var button = div.getElementsByTagName("button")[0];
        button.addEventListener('click', function(e){
            thisRef.$store.commit("restaurant.set", { restaurant: element });
            thisRef.$router.push({ name: "schedule" });
        })
        var infowindow = new google.maps.InfoWindow({
          content: div,
          maxWidth: 350,
          // pixelOffset: 100
        });
        //pixelOffset: new google.maps.Size(0,50),
        marker.infowindow = infowindow;
        marker.restaurantId = element.id;
        return marker;
      });
      this.markers.forEach(marker => {
        marker.addListener("click", function() {
          thisRef.markers.forEach(m => {
            m.infowindow.close();
            // m.setIcon(require("../assets/images/pin.png"));
            m.setIcon({
              anchor: new google.maps.Point(16, 16),
              // url: 'data:image/svg+xml;utf-8, ' + thisRef.pin,
              url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(thisRef.pin)
            });
          });
          marker.infowindow.open(thisRef.map, marker);
          // marker.setIcon(require("../assets/images/pinactive.png"));
          marker.setIcon({
            anchor: new google.maps.Point(16, 16),
            // url: 'data:image/svg+xml;utf-8, ' + thisRef.bigPin,
            url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(thisRef.bigPin)
          });
          thisRef.activeId = marker.restaurantId;
          scrollTo("#id" + thisRef.activeId);
        });
      });
    },
    zoomMarker(restaurant) {
      let thisRef = this;
      this.activeId = restaurant.id;
      var center = new google.maps.LatLng(
        restaurant.latitude,
        restaurant.longitude
      );
      // using global variable:
      this.map.panTo(center);
      this.markers.forEach(marker => {
        if (
          restaurant.latitude == marker.getPosition().lat() &&
          restaurant.longitude ==
            Number(
              marker
                .getPosition()
                .lng()
                .toFixed(7)
            )
        ) {
          // marker.setIcon(require("../assets/images/pinactive.png"));
          marker.setIcon({
            anchor: new google.maps.Point(16, 16),
            // url: 'data:image/svg+xml;utf-8, ' + thisRef.bigPin
            url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(thisRef.bigPin)
          });
          marker.infowindow.open(this.map, marker);
        } else {
          // marker.setIcon(require("../assets/images/pin.png"));
          marker.setIcon({
            anchor: new google.maps.Point(16, 16),
            // url: 'data:image/svg+xml;utf-8, ' + thisRef.pin
            url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(thisRef.pin)
          });
          marker.infowindow.close();
        }
      });
    },
    openOrder() {
      this.$router.push({
        name: "stepOrder"
      });
    },
    buttonChange() {
      this.isMap = this.isMap ? false : true;
      if (this.showList) {
        this.showMap = true;
        this.showList = false;
      } else if (this.showMap) {
        this.showList = true;
        this.showMap = false;
      }
    },
    onResize(e) {
      let width = e.target.innerWidth;
      this.isMobile = width <= 768 ? true : false;
      if (this.isMobile) {
        if (this.showList) {
          this.showMap = false;
        } else {
          this.showMap = true;
        }
      } else {
        this.showMap = true;
        this.showList = true;
      }
    },
    handleScroll() {
      const el = document.scrollingElement || document.documentElement;
      if (el.scrollTop > 180) {
        this.smallHeader = true;
      } else {
        this.smallHeader = false;
        this.showSearch = false;
      }
      var containers = document.getElementsByClassName("location-container");

      // for(let i = 0; i < containers.length; i++){
      //   console.log(containers[0].scrollTop)
      // }
    },
    
    
    makeOrder(restaurant) {
      this.$store.commit("restaurant.set", {restaurant});
      axios.post("https://secure-badlands-41449.herokuapp.com/baskets/create?includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP", {
        "vendorid": restaurant.id
      }).then(basket => {
        this.$store.commit("basket.set", {basket: basket.data});
        this.$router.push({ name: "schedule" });
      }).catch(error => console.log(error));
    },
    makeOrderMap(){
      var btnPop = document.getElementsByClassName('popupbtn');
    }
  },
  created: function() {
    this.onResize({ target: { innerWidth: window.screen.width } });
    window.addEventListener("resize", this.onResize);
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted(){
    this.loadData();
  }
};
</script>
<style scoped>
input
{
   border: none;
  padding: 0;
  background: none;
  outline: none;
}
.full-height{
  height: 100%;
}
.main-top {
 transition: 0.3s;
}
.sticky-header {
  transition: 0.3s;
  position: fixed;
  z-index: 5;
  top: 0;
  height: 116px;
  width: 400px;
  background-color: #ffffff;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  /* border-top-right-radius: 16px;
  border-top-left-radius: 16px; */
  padding: 32px;
}
.sticky-header img {
  height: 60px;
  width: 60px;
  border-radius: 15px;
}
.sticky-search {
  box-sizing: border-box;
  height: 62px;
  width: 122px;
  border: 2px solid rgba(0, 0, 0, 0.05);
  border-radius: 30px;
  background-color: #ffffff;
  transition: 0.3s;
  padding: 5px;
}
.sticky-search i {
  height: 18px;
  width: 18px;
  opacity: 0.3;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 18px;
  line-height: 18px;
}
.sticky-search input {
  transition: 1s;
  display: none;
  border: none;
  width: 150px;
}
.show-search{
  transition: 1s;
  display: block !important;
  width: 150px !important;
  transition: 0.3s;
}
.show-div
{
  width: 250px;
  transition: 0.3s;
}
.vertical-two {
  box-sizing: border-box;
  height: 36px;
  width: 1px;
  border: 1px solid #000000;
  opacity: 0.1;
}


a {
  text-decoration: none;
  list-style: none;
}
body,
html {
  scroll-behavior: smooth;
  width: 100%;
  height: 100%;
}
.googleMaps {
  height: 100%;
  width: 100%;
  right: 0px;
  z-index: 8;
  position: fixed;
}
.container-maps {
  position: fixed;
  height: 100%;
  width: 100%;
}
.right-corner {
  display: flex;
  position: fixed;
  right: 15px;
  top: 15px;
  z-index: 2;
  box-sizing: border-box;
  height: 62px;
  width: 240px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 30px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.15);
}
.mobile-header {
  display: none;
  /* position: fixed;
  bottom:0px;
  z-index: 6; */
  box-sizing: border-box;
  height: 62px;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
  /* border-radius: 30px; */
  background-color: #ffffff;
  justify-content: center;
  align-items: center;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.15);
}
button {
  border: none;
  padding: 0;
  background: none;
  outline: none;
}
.signIn {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: #000000;
}
.signIn i {
  height: 21px;
  width: 20px;
  opacity: 0.8;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
}
.signIn span {
  margin-left: 10px;
}
.mapbtn {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: #000000;
}
.mapbtn i {
  height: 21px;
  width: 20px;
  opacity: 0.8;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
}
.mapbtn span {
  margin-left: 10px;
}
.vertical-line {
  box-sizing: border-box;
  height: 36px;
  width: 1px;
  border: 1px solid #000000;
  opacity: 0.1;
}
.basket {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: var(--main-color);
}
.basket i {
  height: 21px;
  width: 18px;
  color: var(--main-color);
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
  text-align: center;
}
.basket span {
  margin-left: 10px;
}
.search-block {
  box-sizing: border-box;
  height: 62px;
  width: 338px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.search-block i:first-child {
  height: 18px;
  width: 18px;
  font-family: "Font Awesome 5 Pro";
  font-size: 18px;
  line-height: 18px;
}
.search-block i:last-child {
  height: 18px;
  width: 18px;
  opacity: 0.3;
  /* color: #000000; */
  font-family: "Font Awesome 5 Pro";
  font-size: 18px;
  font-weight: 300;
  line-height: 18px;
}
.search-block input[type="search"] {
  border: none;
  width: 240px;
}
.search-block input::placeholder {
  font-family: "Poppins", sans-serif;
  color: #000000;
  opacity: 0.3;
  font-size: 16px;
  line-height: 25px;
}
.rest-block {
  position: absolute;
  left: 15px;
  top: 15px;
  z-index: 2;
  /* height: 100%; */
  width: 402px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.15);
  overflow-y: scroll !important;
}
.title {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 24px;
  text-transform: uppercase;
  opacity: 0.8;
  line-height: 35px;
  color: #000000;
  text-align: left;
}
.subTitle {
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;
  opacity: 0.4;
  line-height: 20px;
  color: #000000;
  text-align: left;
}
.location-text {
  text-transform: capitalize;
  opacity: 0.6;
  font-family: "Poppins", sans-serif;
  color: #000000;
  font-size: 20px;
  line-height: 30px;
  font-weight: 300;
  /* margin-top: 48px;
  margin-left: 33px; */
  text-align: left;
}
.location-left {
  width: 60%;
  padding: 24px 30px;
  transition: 1s;
}
.location-right {
  width: 50%;
  transition: 1s;
  padding-right:36px;
}
.right-btn {
  height: 48px;
  width: 134px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 24px;
  background-color: #ffffff;
  font-family: "Poppins", sans-serif;
  color: var(--main-color);
  font-size: 11px;
  font-weight: bold;
  transition: 1s;
}
.right-btn i {
  height: 16px;
  width: 14px;
  color: var(--main-color);
  font-family: "Font Awesome 5 Pro";
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  margin-right: 10px;
  transition: 1s;
}
.right-btn span {
  height: 19px;
  width: 71px;
  color: var(--main-color);
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: bold;
  line-height: 20px;
  transition: 1s;
}
.location-left h1 {
  font-family: "Poppins", sans-serif;
  opacity: 0.8;
  font-weight: bold;
  font-size: 14px;
}
.location-left p {
  font-family: "Poppins", sans-serif;
  font-size: 11px;
  font-weight: 500;
  opacity: 0.6;
  margin: 0;
  line-height: 17px;
  text-align: left;
}
.location-left p > img {
  width: 18px;
  height: 14px;
}
.location-container {
  width: 100%;
}
.line-between {
  box-sizing: border-box;
  height: 1px;
  width: 100%;
  border: 1px solid #000000;
  opacity: 0.05;
}
.logo-title {
  padding: 25px;
}
.logo-title img {
  /* width: 96px; */
  height: 96px;
  border-radius: 25px;
}
.description {
  display: table-cell;
  vertical-align: middle;
  /* padding: 5px 10px; */
  margin-top: 5px;
}
.description p {
  /* height: 38px;
    width: 121px; */
  opacity: 0.6;
  color: #000000;
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 8px;
  display: inline-block;
  vertical-align: middle;
}
.description p i {
  height: 16px;
  width: 18px;
  opacity: 0.3;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 16px;
  line-height: 16px;
  margin-left: 5px;
}
.first-col i {
  height: 16px;
  width: 18px;
  opacity: 0.3;
  /* color: #000000; */
  font-family: "Font Awesome 5 Pro";
  font-size: 16px;
  line-height: 16px;
  margin-top: 2px;
  margin-right: 8px;
}
.first-col p {
  opacity: 0.6;
  color: #000000;
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 8px;
}
.icon i {
  height: 16px;
  width: 18px;
  opacity: 0.3;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 16px;
  line-height: 16px;
  text-align: center;
}
.location-container:hover .location-left {
  background-color: rgba(255, 251, 0, 0.1);
  transition: 1s;
}
.location-container:hover .location-right .right-btn {
  background-color: var(--main-color);
  transition: 1s;
}
.location-container:hover .location-right {
  background-color: rgba(255, 251, 0, 0.1);
  transition: 1s;
}
.location-container:hover .location-right .right-btn i {
  color: white;
  transition: 1s;
}
.location-container:hover .location-right .right-btn span {
  color: white;
  transition: 1s;
}
.active-click .location-left {
  background-color: rgba(255, 251, 0, 0.1);
  transition: 1s;
}
.active-click .location-right .right-btn {
  background-color: var(--main-color);
  transition: 1s;
}
.active-click .location-right {
  background-color: rgba(255, 251, 0, 0.1);
  transition: 1s;
}
.active-click .location-right .right-btn i {
  color: white;
  transition: 1s;
}
.active-click .location-right .right-btn span {
  color: white;
  transition: 1s;
}
.current-button {
  color: var(--main-color);
}
@media only screen and (max-width: 768px) {
  .right-corner {
    display: none;
  }
  .mobile-header {
    display: flex;
    position: fixed;
    z-index: 10;
    bottom: 0px;
    /* transform: translate(40%, 30%); */
  }
  .rest-block {
    /* height: 100%; */
    /* width:auto;
    position: relative;
    top:0; */
    width: 100%;
    left: 0px;
    top: 0px;
  }
  .logo-title {
    flex-direction: column !important;
  }
  .logo-col {
    justify-content: center !important;
    align-items: center !important;
  }
  .subTitle {
    text-align: center;
  }

  .container-maps {
    height: 100%;
    width: 100%;
    z-index: 4;
    top: 130px;
  }
  /* #locationdiv>.location-container:last-child {
  margin-bottom: 50px;
 } */
  .location-text {
    margin-left: 100px;
  }

  #locationdiv > div:nth-child(1) > div:nth-child(7) > div:nth-child(2) {
    margin-bottom: 50px;
  }
  .show-all {
    justify-content: center !important;
    padding-left: 0px !important;
  }
}
.search-res {
  text-transform: uppercase;
  opacity: 0.4;
  color: #000000;
  font-family: Poppins;
  font-size: 16px;
  font-weight: bold;
  line-height: 25px;
}

.search-res-block {
  width: 100%;
  padding-top: 31px;
  padding-bottom: 10px;
}
.view-allloc {
  opacity: 0.6;
  color: #000000;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 500;
  line-height: 25px;
  text-align: right;
  text-decoration: underline;
}

.allLoc {
  text-transform: uppercase;
  opacity: 0.4;
  color: #000000;
  font-family: Poppins;
  font-size: 16px;
  font-weight: bold;
  line-height: 25px;
}

.show-all {
  width: 100%;
  padding-top: 31px;
  padding-bottom: 10px;
  padding-left: 31px;
}
</style>
<style>
.location-left {
  padding: 24px 30px;

}
.location-left h1 {
  font-family: "Poppins", sans-serif;
  opacity: 0.8;
  font-weight: bold;
  font-size: 14px;
}
.location-left p {
  font-family: "Poppins", sans-serif;
  font-size: 11px;
  font-weight: 500;
  opacity: 0.6;
  margin: 0;
  line-height: 17px;
  text-align: left;
}
.description {
  display: table-cell;
  vertical-align: middle;
  /* padding: 5px 10px; */
  margin-top: 5px;
}
.description p {
  /* height: 38px;
    width: 121px; */
  opacity: 0.6;
  color: #000000;
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 8px;
  display: inline-block;
  vertical-align: middle;
}
.description p i {
  height: 16px;
  width: 18px;
  opacity: 0.3;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 16px;
  line-height: 16px;
  margin-left: 5px;
}
.first-col i {
  height: 16px;
  width: 18px;
  opacity: 0.3;
  /* color: #000000; */
  font-family: "Font Awesome 5 Pro";
  font-size: 16px;
  line-height: 16px;
  margin-top: 2px;
  margin-right: 8px;
}
.first-col p {
  opacity: 0.6;
  color: #000000;
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 8px;
}
.popup-btn {
  height: 48px;
  width: 134px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 24px;
  background-color: #ffffff;
  font-family: "Poppins", sans-serif;
  color: var(--main-color);
  font-size: 11px;
  font-weight: bold;
  transition: 1s;
}
.popup-btn i {
  height: 16px;
  width: 14px;
  color: var(--main-color);
  font-family: "Font Awesome 5 Pro";
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  margin-right: 10px;
  transition: 1s;
}
.popup-btn span {
  height: 19px;
  width: 71px;
  color: var(--main-color);
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: bold;
  line-height: 20px;
  transition: 1s;
}
.location-right {
  width: 50%;
  transition: 1s;
}
</style>



// WEBPACK FOOTER //
// src/components/startPage.vue